import { Component } from '@angular/core';
import { OrderListComponent } from 'gung-standard';

@Component({
    selector: 'otto-olsen-delivery-overview',
    templateUrl: './otto-olsen-delivery-overview.component.html',
    styleUrl: './otto-olsen-delivery-overview.component.scss',
    standalone: false
})
export class OttoOlsenDeliveryOverviewComponent extends OrderListComponent {
  
}
